<template>
        <v-card
          :style="{ backgroundColor: !image ? bgColor : null }"
        >
          <v-img
            :src="image ? image : emptyImage"
            :lazy-src="image ? 'https://www.dtouch.es/img/lazy.png' : emptyImage"
            :key="ID"
            class="white--text align-end"
            :gradient="image ? 'to bottom, rgba(0,0,0,.1), rgba(0,0,0,.6)' : null"
            height="180px"
            @click="onSelectMenu(card)"
          >
            <v-card-title 
              v-text="text" 
              style="word-break: break-word;line-height:1.2;"
              :style="{ 
                color: !image ? textColor : null, 
                fontSize: `${fontSize}px`,
                fontFamily: font
              }"
            />
            </v-card-title>
          </v-img>
        </v-card>
</template>
<script>
export default {
  props: {
    card: {
      type: Object,
      required: true,
    },
    ID: {
      type: String,
      required: true,
    },
    image: {
      type: String,
      default: null,
    },
    bgColor: {
      type: String,
      default: null,
    },
    textColor: {
      type: String,
      default: null,
    },
    onSelectMenu: {
      type: Function,
      default: null,
    },
    fontSize: {
      type: [String, Number],
      default: null,
    },
    font: {
      type: String,
      default: null,
    },
    text: {
      type: String,
      default: null,
    },
  },
  computed: {
    emptyImage () {
      return "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAEAAAABCAYAAAAfFcSJAAABhGlDQ1BJQ0MgcHJvZmlsZQAAKJF9kT1Iw0AcxV9TxVoqgnYQcchQneyiIrrVKhShQqgVWnUwufQLmjQkKS6OgmvBwY/FqoOLs64OroIg+AHi6uKk6CIl/i8ptIj14Lgf7+497t4BQr3MNKsrBmi6baYScTGTXRV7XtGLAIKYxYDMLGNOkpLoOL7u4ePrXZRndT735+hTcxYDfCJxjBmmTbxBPL1pG5z3icOsKKvE58TjJl2Q+JHrisdvnAsuCzwzbKZT88RhYrHQxkobs6KpEU8RR1RNp3wh47HKeYuzVq6y5j35C0M5fWWZ6zRHkMAiliBBhIIqSijDRpRWnRQLKdqPd/APu36JXAq5SmDkWEAFGmTXD/4Hv7u18pMTXlIoDnS/OM7HKNCzCzRqjvN97DiNE8D/DFzpLX+lDsx8kl5raZEjoH8buLhuacoecLkDDD0Zsim7kp+mkM8D72f0TVlg8BYIrnm9Nfdx+gCkqavkDXBwCIwVKHu9w7sD7b39e6bZ3w+aBHK2G7iMhgAAAAZiS0dEAP8A/wD/oL2nkwAAAAlwSFlzAAAuIwAALiMBeKU/dgAAAAd0SU1FB+cJCAo6GUNkOGsAAAAZdEVYdENvbW1lbnQAQ3JlYXRlZCB3aXRoIEdJTVBXgQ4XAAAAEElEQVQIHQEFAPr/AAAAAAAABQABuokQigAAAABJRU5ErkJggg=="
    },
  },
  watch: {
    font () {
      console.log('2', this.font)
    },
  },
  mounted () {
    console.log('1', this.font)
  },
}
</script>
